function DOMready(callback) {
  if (document.readyState != 'loading') callback()
  else document.addEventListener('DOMContentLoaded', callback)
}

DOMready(function () {
  const tabNameArr = document.querySelectorAll(".rootcauses-column__tab-name");

  if (tabNameArr.length > 0) {
    tabNameArr.forEach((tab) => {
      if (tab.classList.contains("js-active")) {
        const activeTabInner = tab.querySelector(".rootcauses-column__tab-name-info");
        if (activeTabInner != null) {
          activeTabInner.style.maxHeight = activeTabInner.scrollHeight + "px";
        }
      }

      tab.addEventListener("click", (event) => {
        event.preventDefault();

        const activeTab = document.querySelector(".rootcauses-column__tab-name.js-active"),
          activeTabInners = document.querySelectorAll(".rootcauses-column__tab-name-info"),
          images = document.querySelectorAll(".rootcauses-column__img"),
          contents = document.querySelectorAll(".rootcauses-column__info"),
          dataId = tab.getAttribute("data-id");

        activeTab.classList.remove("js-active");
        tab.classList.add("js-active");

        if (activeTabInners.length > 0) {
          activeTabInners.forEach((activeTabInner) => {
            if (activeTabInner.parentElement.classList.contains("js-active")) {
              activeTabInner.style.maxHeight = activeTabInner.scrollHeight + "px";
            } else {
              activeTabInner.style.maxHeight = null;
            }
          });
        }

        images.forEach((image) => {
          image.classList.remove("js-active");
          image.classList.add("hidden");

          if (dataId === image.getAttribute("data-id")) {
            image.classList.add("js-active");
            image.classList.remove("hidden");
          }
        });

        contents.forEach((content) => {
          content.classList.remove("js-active");
          content.classList.add("hidden");

          if (dataId === content.getAttribute("data-id")) {
            content.classList.add("js-active");
            content.classList.remove("hidden");
          }
        });
      });
    });
  }
})
